import React from 'react'
import Link from 'gatsby-link'

export default () => {
  return (
    <footer style={{textAlign: 'center', padding: '10px', backgroundColor: '#333028', margin: 0, height: '50px'}}>
      <Link className="navbar-item" to="/about" style={{padding: '20px', color: '#ffffff', textDecoration: 'none'}}>
        About Us
      </Link>
      <Link className="navbar-item" to="/terms" style={{padding: '20px', color: '#ffffff', textDecoration: 'none'}}>
        Terms
      </Link>
      <Link className="navbar-item" to="/privacy" style={{padding: '20px', color: '#ffffff', textDecoration: 'none'}}>
        Privacy
      </Link>
    </footer>
  )
}



// WEBPACK FOOTER //
// ./src/components/Footer.js